export default __webpack_public_path__ + "static/doublo-design-00e09bb85c752415fe49832eac87c94c.gif";